import { cloneDeep } from 'lodash';

const SET_PROMO_MESSAGE = 'SET_PROMO_MESSAGE';
const SET_PROMO_MESSAGE_FALSE = 'SET_PROMO_MESSAGE_FALSE';

const initialStatePromoMessage = false;

export default function reducer(state = cloneDeep(initialStatePromoMessage), action) {
	switch (action.type) {
		case SET_PROMO_MESSAGE:
			return action.payload;
		case SET_PROMO_MESSAGE_FALSE:
			return false;
		default:
			return state;
	}
}

export function firePromoMessage( obj ){
  return {
    type: SET_PROMO_MESSAGE,
    payload: obj
  }
}

export function clearPromoMessage(){
  return { type: SET_PROMO_MESSAGE_FALSE }
}


// WEBPACK FOOTER //
// ./src/modules/promo_message.js